import React from 'react';
import '../styles/Styles.css';
import logoImageFooter from "../assets/images/logo-footer.png";

const Footer = () => {
  const menuLinks = [
    { text: 'Главная', href: '/' },
    { text: 'Каталог', href: '/cars' },
    { text: 'О нас', href: '/about' },
    { text: 'Условия аренды', href: '/terms' },
    { text: 'Контакты', href: '/contacts' }
  ];

  const contactInfo = [
    { icon: 'fas fa-map-marker-alt', text: 'Калининград, ул. Калининградская 35А, корп. 1' },
    { icon: 'fas fa-phone', text: '+7 (962) 269-99-94' },
    { icon: 'fas fa-envelope', text: 'booking@reservecar.ru' },
    { icon: 'fas fa-clock', text: 'Ежедневно: 8:00 - 20:00' }
  ];

  //const socialLinks = [
    //{ icon: 'fab fa-facebook-f', href: '#' },
    //{ icon: 'fab fa-twitter', href: '#' },
    //{ icon: 'fab fa-instagram', href: '#' },
    //{ icon: 'fab fa-linkedin-in', href: '#' }
  //];

  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <a href="/" className="logo">
              <img src={logoImageFooter} alt="Logo" className="logo-image-footer" />
            </a>
            <p className="footer-description">Аренда автомобилей в Калининграде.</p>
            {/*<div className="social-links">
              {socialLinks.map((link, index) => (
                <a key={index} href={link.href} className="social-link">
                  <i className={link.icon}></i>
                </a>
              ))}
            </div> */}
          </div>

          <div className="footer-col">
            <h3>Меню</h3>
            <ul className="footer-links">
              {menuLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href}>{link.text}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h3>Информация</h3>
            <ul className="footer-links">
                <li ><a href='../agreements'>Пользовательское соглашение</a></li>
                <li ><a href='../privacy'>Политика конфиденциальности</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h3>Контакты</h3>
            <ul className="footer-links">
              {contactInfo.map((info, index) => (
                <li key={index}>
                  <i className={info.icon}></i>
                  {info.text}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="copyright">
          <p>© 2025 Reserve Car. Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;